module.exports = __webpack_public_path__ + "img/ma-back.b70711de.png";